<template>
  <div class="question-content">
    <div class="per-button top-btn" @click="goBack">返回</div>
    <div class="question">
      <div class="question-news">
        <img :src="userInfo.photo" alt="" />
      </div>
      <div class="question-info">
        <p>{{ question_title }}</p>
        <p>{{ question_time }}</p>
      </div>
    </div>
    <div
      class="replys"
      :style="
        !questionList.teaName ? { display: 'none' } : { display: 'block' }
      "
    >
      <div class="replys-item">
        <div class="main">
          <div class="placeholder">{{ questionList.teaName + '：' }}</div>
          <div class="content">
            <p>{{ questionList.answer }}</p>
            <p>{{ questionList.answer_time }}</p>
          </div>
          <div class="placeholder vc cp" @click="handleReply(1)">追问</div>
        </div>
        <div class="more" v-for="item in questionList.child" :key="item.id">
          <div class="placeholder">{{ item.stuName + '：' }}</div>
          <div class="content">
            <p>{{ item.question }}</p>
            <p class="stu_c">{{ item.created_at }}</p>
            <div class="teacher_answer_box" v-show="item.teaName != ''">
              <div class="teacher_name">{{ item.teaName + '：' }}</div>
              <div class="teacher_answer_content">
                <div>{{ item.answer }}</div>
                <div class="answer_time">{{ item.answer_time }}</div>
              </div>
            </div>
          </div>
        </div>
        <transition name="component-fade" mode="out-in">
          <div class="input-reply" v-if="current === 1">
            <el-input
              type="textarea"
              :rows="3"
              placeholder="请输入内容"
              v-model="reply"
            >
            </el-input>
            <div class="per-button btn-active" @click="sendQuestion()">
              发送
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { questionInfo, questioning } from '@/api/personalCenter/index.js'
export default {
  name: 'question-content',
  components: {},
  props: [],
  data() {
    return {
      reply: '',
      current: undefined,
      questionList: {},
    }
  },
  watch: {},
  computed: {
    ...mapState({
      selectQuestion_Id: (state) => state.personal.selectQuestion_Id,
      question_title: (state) => state.personal.question_title,
      question_time: (state) => state.personal.question_time,
      userInfo: (state) => state.userInfo,
      questionShow: (state) => state.personal.questionShow,
    }),
    serverUrl() {
      return this.publicData.serverUrl
    },
  },
  created() {
    this.loadRequests()
  },
  mounted() {},
  methods: {
    handeChange() {},
    handleReply(i) {
      if (this.current === i) {
        this.current = undefined
      } else {
        this.current = i
        this.reply = ''
      }
    },
    loadRequests() {
      questionInfo(this.selectQuestion_Id).then((res) => {
        const { data } = res
        this.questionList = data
      })
    },
    sendQuestion() {
      var data = {
        id: this.selectQuestion_Id,
        question: this.reply,
      }
      questioning(data).then((res) => {

        this.$notify({
          type: 'success',
          message: res.msg,
          duration: 1500,
          title: 'SUCCESS',
        })
        this.loadRequests()
      })
    },
    goBack() {
      var that = this
      this.$emit('change', true)
      if (this.questionShow > 0) {
        this.$store.dispatch('personal/setQuestionShowAsync')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.question-content {
  position: relative;
  width: 100%;
  height: 100%;
  font-size: 14px;
  color: #666666;
  background-color: #ffffff;
  padding: 20px 40px;
  border-radius: 4px;
  .top-btn {
    position: absolute;
    top: -40px;
    right: 0;
  }
  .question {
    width: 100%;
    display: flex;
    align-items: center;
    img {
      width: 3vw;
      height: 3vw;
      border-radius: 50%;
    }
    &-info {
      width: 100%;
      padding: 15px 20px;
      p {
        font-size: 14px;
        margin: 0;
        &:last-child {
          font-size: 12px;
          margin-top: 10px;
        }
      }
    }
  }
  .replys {
    width: 100%;
    padding: 10px 30px;
    background-color: #edf2f6;
    border-radius: 5px;
    margin-bottom: 2px;
    &-item {
      .main,
      .more {
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding: 10px 0;
        .content {
          width: 100%;
          padding: 0 18px;
          p {
            font-size: 14px;
            margin: 0;
            &:last-child {
              font-size: 12px;
              margin-top: 10px;
            }
          }
        }
        .placeholder {
          color: #0c5893;
          flex-shrink: 0;
          user-select: none;
        }
      }
      .more {
        padding-left: 3rem;
        border-top: 1px solid #dadada;
      }
      .input-reply {
        width: 100%;
        padding-left: 3rem;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        ::v-deep .el-textarea {
          .el-textarea__inner {
            font-size: 14px;
          }
        }
        .per-button {
          margin-top: 10px;
        }
      }
    }
  }
}
.teacher_answer_box {
  width: 100%;
  background: rgba($color: #000, $alpha: 0.08);
  .teacher_name {
    display: inline-block;
    height: 100%;
    vertical-align: top;
    color: #0c5893;
  }
  .teacher_answer_content {
    display: inline-block;
    margin-left: 10px;
  }
}

.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active for below version 2.1.8 */ {
  opacity: 0;
}
.answer_time {
  font-size: 12px;
}
.stu_c {
  font-size: 12px !important;
}
</style>